<template lang="pug">
  .payment-options__wrapper(class="z-1")
    .payment-options(
      :class="[{'payment-options--active': selectedPaymentMethod && !toggle, 'payment-options--expand': toggle}]"
      @click.prevent="onClick"
    )
      span.payment-options__label-default(v-if="!selectedPaymentMethod || toggle") Selecione um meio de pagamento

      span.payment-options__option-selected(v-else)
        img.payment-options__option-selected__logo(
          :src="selectedPaymentMethod.logo"
          :title="selectedPaymentMethod.title"
          :alt="selectedPaymentMethod.title"
        )
        strong {{ selectedPaymentMethod.title }}
        span.payment-options__option-selected__change Alterar

      transition(
        name="payment-options__list"
        @after-enter="endTransition"
        @after-leave="endTransition"
        @before-leave="startTransition"
        @enter="startTransition"
      )
        ol.payment-options__list(v-show="toggle")
          li.payment-options__list__item(
            v-for="(option, index) in methodsOptions"
            :key="option.method"
            @click.prevent="selectedOption(index)"
          )
            img.payment-options__list__item__logo(
              :src="option.logo"
              :title="option.title"
              :alt="option.title"
            )
            div.payment-options__list__item__description
              strong {{ option.title }}
              span(v-if="option.description") ({{ option.description }})
</template>
<script>
export default {
  name: 'PaymentOptions',
  props: {
    methodsOptions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      toggle: false,
      selectedPaymentMethod: null
    }
  },
  computed: {
    enablePromoCode () {
      return this.plan.promoCode.enable === true
    }
  },
  methods: {
    startTransition (el) {
      el.style.height = `${el.scrollHeight}px`
    },
    endTransition (el) {
      el.style.height = ''
    },
    onClick () {
      this.toggle = !this.toggle
    },
    selectedOption (item) {
      if (this.selectedPaymentMethod === this.methodsOptions[item]) return

      this.selectedPaymentMethod = this.methodsOptions[item]
      this.$emit('selectedOption', this.selectedPaymentMethod)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .payment-options {
    background-color: #fff;
    border: solid 1px #bdc2c6;
    border-radius: 8px;
    color: #444444;
    cursor: pointer;
    font-family: $rubik-font-family;
    font-size: 16px;
    position: absolute;
    overflow: hidden;
    width: 100%;

    &__wrapper {
      height: 90px;
      max-width: 411px;
      position: relative;

      @media screen and (min-width: 390px) {
        height: 66px;
      }
    }

    &:after {
      background-image: url('~@/assets/icons/arrow.svg');
      background-position: center;
      background-repeat: no-repeat;
      content: '';
      position: absolute;
      top: 32px;
      right: 24px;
      width: 24px;
      height: 24px;
      transition: transform .2s ease;

      @media screen and (min-width: 375px) {
        top: 20px
      }
    }

    &--expand {
      box-shadow: 0 2px 4px 0 rgba(0,0,0,.1);

      &:after {
        transform: rotate(180deg);
      }
    }

    &--active {
      border: solid 1px #1A71B4;
      background-color: #1a71b417;

      &:after {
        background-image: none;
      }
    }

    &__label-default {
      color: #595959;
      display: inline-block;
      line-height: 1.5;
      padding: 20px 65px 20px 24px;
    }

    &__option-selected {
      align-items: center;
      display: flex;
      padding: 16px 80px 16px 24px;

      &__change {
        color: #373739;
        font-size: 14px;
        position: absolute;
        right: 24px;
      }
    }

    &__list {
      &-enter-active,
      &-leave-active {
        transition: height 200ms ease;
        will-change: height;
      }

      &-enter,
      &-leave-to {
        height: 0 !important;
      }

      &__item {
        align-items: center;
        border-top: 1px solid rgba(#bdc2c6, 0.3);
        display: flex;
        padding: 16px 24px;
        transition: background-color .2s linear;

        &:hover {
          background-color: #1a71b417;
        }

        &__description {
          strong {
            margin-right: 4px;

            @media screen and (max-width: 425px) {
              display: block;
              margin-bottom: 4px;
            }
          }

          span {
            color: #595959;
            font-size: 14px;
          }
        }
      }
    }

    &__option-selected__logo,
    &__list__item__logo {
      height: 32px;
      margin-right: 16px;
      min-width: 32px;
    }
  }
</style>
